import { render, staticRenderFns } from "./child-kv.vue?vue&type=template&id=5babec4b&scoped=true"
import script from "./child-kv.vue?vue&type=script&lang=js"
export * from "./child-kv.vue?vue&type=script&lang=js"
import style0 from "./child-kv.vue?vue&type=style&index=0&id=5babec4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babec4b",
  null
  
)

export default component.exports